import { render } from "./paymentStatus.vue?vue&type=template&id=d52959cc"
import script from "./paymentStatus.vue?vue&type=script&lang=js"
export * from "./paymentStatus.vue?vue&type=script&lang=js"

import "./paymentStatus.vue?vue&type=style&index=0&id=d52959cc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__